<template>
  <b-modal centered
           id="server-update-status-popup"
           ref="server-update-status-popup"
           v-bind:visible="showServerUpdateStatusPopup"
           size="lg"
           :title="hebrew ? 'סטטוס עדכון שרת' : 'Server Update Status'"
           hide-header-close
           footer-class="bordered-footer"
           :ok-title="hebrew ? 'סגור' : 'Close'"
           ok-variant="secondary"
           @hidden="clearStatusText"
           body-class="scroll-modal"
           ok-only>
      <p dir="ltr" class="status-line" v-for="(statusLine, i) in statusLines" :key="'statusLine' + i">
        {{ statusLine }}
      </p>
  </b-modal>
</template>

<script>
import {serverUpdateStatus} from '@/js/triggerServerUpdate'
import Vue from 'vue'

export default {
  name: 'ServerUpdateStatusPopup',
  data () {
    return {
      showServerUpdateStatusPopup: false
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    statusLines () {
      return serverUpdateStatus.text.split('\n')
    }
  },
  watch: {
    showServerUpdateStatusPopup (newShowServerUpdateStatusPopup) {
      if (newShowServerUpdateStatusPopup) this.$refs['server-update-status-popup'].show()
    },
    statusLines () {
      if (serverUpdateStatus.text) {
        this.showServerUpdateStatusPopup = true
        // scroll to bottom?
      }
    }
  },
  methods: {
    clearStatusText () {
      this.showServerUpdateStatusPopup = false
      Vue.set(serverUpdateStatus, 'text', '')
    }
  }
}
</script>
<style scoped>
#server-update-status-popup p {
  text-align: center;
}
</style>
